import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectors, actions } from 'shared/store'
import { UserRole } from 'shared/types'
import { useUserRole } from './useUserRole'

export const useAccountantCompanies = () => {
  const { data, loading } = useSelector(
    selectors.companies.getAccountantCompaniesState
  )
  const { isAllowed } = useUserRole()
  const dispatch = useDispatch()

  const companyId = useSelector(selectors.companies.getSelectedCompanyId)

  useEffect(() => {
    if (isAllowed(UserRole.Accountant)) {
      dispatch(
        actions.companies.getAccountantCompanies({ disableRefetch: true })
      )
    }
  }, [dispatch, isAllowed])

  useEffect(() => {
    if (data.length === 1 && isAllowed(UserRole.Accountant))
      dispatch(actions.companies.selectCompanyId(data[0].id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isAllowed])

  const selectedCompany = data.find(company => `${company.id}` === companyId)

  return {
    data,
    selectedCompany,
    loading,
  }
}
